// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 2rem 0;
}

.leaderboard-table {
  width: 100%;
}

.leaderboard-header-row {
  display: grid;
  grid-template-columns: 80px 1fr 140px;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: #f7fafc;
  border-bottom: 2px solid #e2e8f0;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #4a5568;
}

.leaderboard-body {
  /* Removed max-height and overflow-y to show full table without scrolling */
}

.leaderboard-empty {
  padding: 3rem;
  text-align: center;
  color: #718096;
  background: #f7fafc;
  border-radius: 8px;
}

.leaderboard-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: #f7fafc;
  border-top: 1px solid #e2e8f0;
  font-size: 0.875rem;
  color: #718096;
  flex-wrap: wrap;
  gap: 1rem;
}

.entry-count {
  font-weight: 500;
}

.tied-ranks-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #4a5568;
}

.info-icon {
  font-size: 1rem;
}

/* Column headers */
.rank-column {
  text-align: center;
}

.user-column {
  text-align: left;
}

.tasks-column {
  text-align: center;
}


/* Responsive design */
@media (max-width: 768px) {
  .leaderboard-header-row {
    grid-template-columns: 60px 1fr 100px;
    gap: 0.5rem;
    padding: 1rem;
    font-size: 0.8rem;
  }


  .leaderboard-footer {
    padding: 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .tied-ranks-info {
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .leaderboard-header-row {
    grid-template-columns: 50px 1fr 80px;
    padding: 0.75rem;
    font-size: 0.75rem;
  }

  .leaderboard-footer {
    padding: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/leaderboard/LeaderboardTable.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".leaderboard-table-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin: 2rem 0;\n}\n\n.leaderboard-table {\n  width: 100%;\n}\n\n.leaderboard-header-row {\n  display: grid;\n  grid-template-columns: 80px 1fr 140px;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  background: #f7fafc;\n  border-bottom: 2px solid #e2e8f0;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #4a5568;\n}\n\n.leaderboard-body {\n  /* Removed max-height and overflow-y to show full table without scrolling */\n}\n\n.leaderboard-empty {\n  padding: 3rem;\n  text-align: center;\n  color: #718096;\n  background: #f7fafc;\n  border-radius: 8px;\n}\n\n.leaderboard-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background: #f7fafc;\n  border-top: 1px solid #e2e8f0;\n  font-size: 0.875rem;\n  color: #718096;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.entry-count {\n  font-weight: 500;\n}\n\n.tied-ranks-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  color: #4a5568;\n}\n\n.info-icon {\n  font-size: 1rem;\n}\n\n/* Column headers */\n.rank-column {\n  text-align: center;\n}\n\n.user-column {\n  text-align: left;\n}\n\n.tasks-column {\n  text-align: center;\n}\n\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .leaderboard-header-row {\n    grid-template-columns: 60px 1fr 100px;\n    gap: 0.5rem;\n    padding: 1rem;\n    font-size: 0.8rem;\n  }\n\n\n  .leaderboard-footer {\n    padding: 1rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .tied-ranks-info {\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .leaderboard-header-row {\n    grid-template-columns: 50px 1fr 80px;\n    padding: 0.75rem;\n    font-size: 0.75rem;\n  }\n\n  .leaderboard-footer {\n    padding: 0.75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
